const WORDS = ["Verify", "Authenticate", "Attest", "Prove", "Trust nothing", "Sign everything"];

export const Marquee = () => {
  const seq = [...WORDS, ...WORDS];
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {seq.map((w, i) => (
          <span className="item" key={i}>{w}<span className="s">/</span></span>
        ))}
      </div>
    </div>
  );
};
